"use client";

import { Box, Container } from "@mui/material";
import { useMemo } from "react";
import { toAssetImages } from "src/lib/utils";
import RichContentRenderer from "./RichContentRenderer";

export interface VariantProps {
  content?: string;
  maxWidth?: "sm" | "md" | "lg" | "full";
}

const containerMap = {
  sm: "sm",
  md: "md",
  lg: "lg",
  full: false,
} as const;

const resolveContentAssetUrls = (html: string) => {
  if (!html?.trim()) return "";
  return html.replace(/src=(["'])([^"']+)\1/g, (_match, quote, src) => {
    const value = String(src || "").trim();
    if (
      !value ||
      value.startsWith("http://") ||
      value.startsWith("https://") ||
      value.startsWith("data:")
    ) {
      return `src=${quote}${value}${quote}`;
    }
    return `src=${quote}${toAssetImages(value)}${quote}`;
  });
};

const EditorDefaultV2 = ({ content = "", maxWidth = "lg" }: VariantProps) => {
  const resolvedContent = useMemo(() => resolveContentAssetUrls(content), [content]);
  const containerMaxWidth = containerMap[maxWidth] ?? "lg";

  return (
    <Box component="section" id="rich-content" sx={{ py: { xs: 3, laptop: 4 } }}>
      <Container maxWidth={containerMaxWidth}>
        <RichContentRenderer content={resolvedContent} />
      </Container>
    </Box>
  );
};

export default EditorDefaultV2;
